/* WebComponentNewsletterSignupInitialTsx template */
import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { FormState } from '../types/form-state.enum';
import { ButtonState } from '../types/button-state.enum';
import { SignUpState } from '../types/signup-state.enum';
import { NewsletterSignupComponent } from '../cwc-newsletter-signup';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NewsletterSignupInitialTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: NewsletterSignupComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const NewsletterSignupInitialTemplate: FunctionalComponent<NewsletterSignupInitialTemplateProps> = ({ controller }) => (
  <cwc-newsletter-signup-main>
    <slot name="initial-illustration" />
    <cwc-newsletter-signup-headline style={!controller.initialHeadline ? { display: 'none' } : {}}>
      <slot name="initial-headline" />
    </cwc-newsletter-signup-headline>
    <cwc-newsletter-signup-subheadline style={!controller.initialText ? { display: 'none' } : {}}>
      <slot name="initial-text" />
    </cwc-newsletter-signup-subheadline>
    <cwc-newsletter-signup-text style={!controller.initialAdditionalText ? { display: 'none' } : {}}>
      <slot name="initial-additionaltext" />
    </cwc-newsletter-signup-text>
    <form form-state={controller.formState}>
      {
        controller.signUpState == SignUpState.LOAD ? (
          <csc-loading-animation type="small">
            <csc-loading-animation-dot />
            <csc-loading-animation-dot />
            <csc-loading-animation-dot />
          </csc-loading-animation>
        ) : (
          <input
            type="email"
            name="email"
            placeholder={controller.placeholderText}
            onInput={(event: Event) => controller.emailChanged(event)}
            onChange={(event: Event) => controller.emailChanged(event)}
            onKeyUp={(event: Event) => controller.emailChanged(event)}
          />
        ) // @TODO: replace with input field with floating label, when stylecomponent will exist in the future
      }
      {controller.formState == FormState.INVALID ? <strong>{controller.invalidFormText}</strong> : ''}
      <cwc-newsletter-signup-info>
        <p style={!controller.initialSubtext ? { display: 'none' } : {}}>
          <slot name="initial-subtext" />
        </p>

        <button
          type="submit"
          class="csc-button csc-button-basic csc-button-strong--on-light"
          disabled={controller.buttonCtaState == ButtonState.DISABLED || controller.signUpState == SignUpState.LOAD}
          onClick={(event: Event) => controller.signUp(event)}
        >
          {controller.buttonCtaText}
        </button>
      </cwc-newsletter-signup-info>
    </form>
  </cwc-newsletter-signup-main>
);

export default NewsletterSignupInitialTemplate;
